module.exports = __webpack_public_path__ + "img/emoji-car-blue-240x240.e64bee19.png";